import { t } from "i18next";
import type { Person } from "@/services/api";
import type { MaybeType } from "../types";

export const handlePeriod = (itemStart?: MaybeType<string>, itemEnd?: MaybeType<string>) => {
  return itemStart && itemEnd
    ? `${itemStart}-${itemEnd}`
    : itemStart
      ? `${itemStart}-${t("common.present")}`
      : "";
};

export const handleFullName = (
  firstName?: MaybeType<string>,
  lastName?: MaybeType<string>,
  middleName?: MaybeType<string>,
) => {
  return `${firstName ?? ""} ${middleName ?? ""} ${lastName ?? ""}`;
};

export const handlePersonFullName = (person: Person) => {
  const { firstName, middleName, lastName } = person;

  return `${firstName ?? ""} ${middleName ?? ""} ${lastName ?? ""}`;
};
